/**
 * @generated SignedSource<<efb6bc9fe82d43bb186a40a94e776de9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { Semver } from "@/common/relayCustomScalar";
import { UsernameOrID } from "@/common/relayCustomScalar";
export type UpdateDatasetVersionInput = {
  authors?: ReadonlyArray<DatasetVersionAuthorInput> | null | undefined;
  description?: string | null | undefined;
  license?: string | null | undefined;
  version?: Semver | null | undefined;
};
export type DatasetVersionAuthorInput = {
  registered: UsernameOrID;
  unregistered?: never;
} | {
  registered?: never;
  unregistered: UnregisteredDatasetVersionAuthorInput;
};
export type UnregisteredDatasetVersionAuthorInput = {
  fullName: string;
};
export type EditActionVersionHistoryMutation$variables = {
  id: string;
  input: UpdateDatasetVersionInput;
};
export type EditActionVersionHistoryMutation$data = {
  readonly updateDatasetVersion: {
    readonly version: Semver;
  };
};
export type EditActionVersionHistoryMutation = {
  response: EditActionVersionHistoryMutation$data;
  variables: EditActionVersionHistoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "datasetVersionId",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditActionVersionHistoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "updateDatasetVersion",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EditActionVersionHistoryMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "updateDatasetVersion",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3109b2ba0fa313bfc22cf2f590b8e74",
    "id": null,
    "metadata": {},
    "name": "EditActionVersionHistoryMutation",
    "operationKind": "mutation",
    "text": "mutation EditActionVersionHistoryMutation(\n  $id: ID!\n  $input: UpdateDatasetVersionInput!\n) {\n  updateDatasetVersion(datasetVersionId: $id, input: $input) {\n    version\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4942f6fdddf3fa4f1097b00b59c777d";

export default node;
